import { PagePartialState, PersistentState } from './../../persistentState/type'

export const mapLocalStorageState = ({
  localStorageState,
}: {
  localStorageState: PersistentState
}): PersistentState => {
  const previousCancellationPageState = {
    previousInsuranceCancelled:
      localStorageState?.pageState.history?.anyDriverPreviousInsuranceCancelled,
  }

  // @ts-expect-error will be removed in a post release cleanup
  const ncdSource = localStorageState?.pageState.history?.ncd

  const ncdFromHistoryState = ncdSource
    ? {
        ...(ncdSource?.internationalYears !== undefined && {
          internationalYears: ncdSource?.internationalYears,
        }),
        ...(ncdSource?.ukYears !== undefined && { ukYears: ncdSource?.ukYears }),
      }
    : undefined

  const claimsFreeDiscountState: PagePartialState['claimFreeDiscount'] = {
    ncd: ncdFromHistoryState,
  }
  return {
    ...localStorageState,
    pageState: {
      ...localStorageState.pageState,
      previousCancellation: previousCancellationPageState,
      ...(ncdFromHistoryState !== undefined ? { claimFreeDiscount: claimsFreeDiscountState } : {}),
    },
  }
}
